import './HistoryTabs.css';

import * as React from 'react';

import { History, Location } from 'history';
import { Nav, NavItem, NavLink, TabContent } from 'reactstrap';

export interface Tab {
  label: string;
  name: string;
  testId?: string;
}
export interface HistoryTabsProps {
  history: History;
  location: Location;
  tabs: Tab[];
  basePath: string;
}
export class HistoryTabs extends React.Component<HistoryTabsProps> {
  handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    const name = e.currentTarget.dataset.name;
    let newPath = name === this.props.tabs[0].name ? this.props.basePath : this.props.basePath + '/' + name;
    this.props.history.replace(newPath);
  };

  render() {
    let activeTab = '';
    if (location.pathname === this.props.basePath) {
      activeTab = this.props.tabs[0].name;
    } else {
      activeTab = location.pathname.substring(location.pathname.lastIndexOf('/') + 1);
    }

    return (
      <div>
        <Nav tabs={true} style={{ marginTop: 5 }}>
          {this.props.tabs.map(({ name, label, testId }) => (
            <NavItem key={name}>
              <NavLink
                data-name={name}
                className={activeTab === name ? 'active' : ''}
                onClick={this.handleClick}
                data-testid={testId}
              >
                {label}
              </NavLink>
            </NavItem>
          ))}
        </Nav>
        <TabContent activeTab={activeTab}>{this.props.children}</TabContent>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/HistoryTabs.tsx